import PropTypes from 'prop-types';
import React from 'react';

function HeaderListItem(props) {
  const { url, text } = props;

  return (
    <div className="ontheshow__header-list-item">
      <span className="ontheshow__header-list-item-bullet" />
      <a href={url} className="ontheshow__header-list-item-link">{ text }</a>
    </div>
  );
}

HeaderListItem.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
};

HeaderListItem.defaultProps = {
  url: undefined,
  text: undefined,
};

export default HeaderListItem;
